module.exports = __webpack_public_path__ + "img/inflammatory-response-image.84962982.png";